import { OpenDialogConfirmComponent } from './../dialog/open-dialog-confirm/open-dialog-confirm.component';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { faHeart as faHeartEmpty } from '@fortawesome/free-regular-svg-icons';
import { faHeart as faHeartFull } from '@fortawesome/free-solid-svg-icons';
import { InfosUser } from 'app/shared/models/class/auth/infosUser';
import { BasketWithPrice, BookBasketOffer, SelectBasketOffer, SessionList } from 'app/shared/models/class/basket/basketList';
import { PromoCodePricing } from 'app/shared/models/class/discount/discount';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { SessionBasketBookable, SessionBasketOfferDuplicate } from 'app/shared/models/class/session-basket/session-basket';
import { OfferSession } from 'app/shared/models/class/session/session';
import { WishList } from 'app/shared/models/class/wishlist/wishlist';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { BasketListService } from 'app/shared/services/basketList/basket-list.service';
import { BookingService } from 'app/shared/services/booking/booking.service';
import { ClubService } from 'app/shared/services/club/club.service';
import { DataService } from 'app/shared/services/data/data.service';
import { DiscountService } from 'app/shared/services/discount/discount.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { PdfService } from 'app/shared/services/pdf/pdf.service';
import { SessionBasketService } from 'app/shared/services/session-basket/session-basket.service';
import { TooltipService } from 'app/shared/services/tooltip/tooltip.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { WishlistService } from 'app/shared/services/wishlist/wishlist.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';
import { environment } from 'environments/environment';
import { OpenDialogConfirmBookedComponent } from '../dialog/open-dialog-confirm-booked/open-dialog-confirm-booked.component';
import { OpendialogCustomizeMySessionComponent } from '../dialog/open-dialog-customize-my-session/opendialog-customize-my-session.component';
import { OpendialogLoginComponent } from '../dialog/open-dialog-login/opendialog-login.component';
import { OpendialogCustomizeMyOrdersComponent } from '../dialog/opendialog-customize-my-orders/opendialog-customize-my-orders.component';
import { OpenDialogHelpComponent } from '../dialog/open-dialog-help/open-dialog-help.component';
import { OpenDialogCommentBasketComponent } from '../dialog/open-dialog-comment-basket/open-dialog-comment-basket.component';

@Component({
  selector: 'app-my-shopping-bag',
  templateUrl: './my-shopping-bag.component.html',
  styleUrls: ['./my-shopping-bag.component.scss']
})
export class MyShoppingBagComponent extends SubscriptionBaseComponent implements OnInit {

  faHeartEmpty = faHeartEmpty;
  faHeartFull = faHeartFull;

  myShoppingBag: FullOffer[];
  myShoppingBagSelected: FullOffer[];
  color: ThemePalette = 'primary';
  loading = true;

  offerAddToPayment: FullOffer[] = [];
  userConnected: InfosUser;
  offerIsCompleted: FullOffer[];

  title = 'minimal-example';
  promiseError = null;
  authoToClick = true;
  totalPrice: number;
  innerWidth: number;
  basketWithPrice: BasketWithPrice;

  discountForm: UntypedFormGroup;
  activePromoCode: boolean;
  totalDiscount: object;
  messageDiscount: any;
  quantitySelectedByUser: any;
  userKey: number;
  licences: FullOffer[];
  clubCode: string;
  pdfTrust: any;
  cgvAccepted = false;
  isDemo: boolean;
  wishes: FullOffer[];
  wishesBase: FullOffer[];

  amount = 0;
  amountAdvance = 0;

  constructor(
    private dataService: DataService,
    private authService: AuthService,
    private basketListService: BasketListService,
    private sessionBasketService: SessionBasketService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
    private formBuilder: UntypedFormBuilder,
    private discountService: DiscountService,
    private tooltip: TooltipService,
    private uiService: UiService,
    private clubService: ClubService,
    private sanitizer: DomSanitizer,
    private router: Router,
    private wishListService: WishlistService,
    private pdfService: PdfService,
    private bookingService: BookingService,
    private faIconService: FaiconService,
  ) {
    super();
    this.initForm();
  }

  ngOnInit(): void {
    this.initComponent();
    this.getBasketListUserConnected();
    this.initSub();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }


  isInOfferAddToPayment(offer: FullOffer): boolean {
    const index = this.offerAddToPayment.findIndex(o => o.offerKey === offer.offerKey && offer.clubCode);
    return index === -1 ? false : true;
  }

  checkAddToPayment(offer: FullOffer): boolean {
    const listClubCode = this.offerAddToPayment.filter(o => o.isSelected && o.clubCode).map(o => o.clubCode);
    const check = offer.clubCode === listClubCode[0] || !listClubCode.length ? true : false;
    if (!check) {
      this.uiService.showSnackbar('Vous ne pouvez pas ajouter une offre d\'un club différent dans votre panier');
    }

    return offer.clubCode === listClubCode[0] || !listClubCode.length ? true : false;
  }

  addToPayment(offer: FullOffer): void {
    const selection = new SelectBasketOffer(this.userKey, offer.sessionBasketKey, !offer.isSelected);
    setTimeout(() => {
      this.sessionBasketService.selectBasketOffer(selection).subscribe({
        next: () => {
          this.getBasketListUserConnected('selection');
        }
      });

    });
  }

  // opendialogCustomizeMyOrders(offer: FullOffer): void {
  //   const dialogRef = this.dialog.open(OpendialogCustomizeMyOrdersComponent, {
  //     data: {
  //       offer
  //     },
  //     minWidth: '50%'
  //   });

  //   dialogRef.afterClosed().subscribe({
  //     next: () => {
  //       this.getBasketListUserConnectedFetch();
  //       this.dataService.paramsOfferIsComplete$.next(false);
  //     }
  //   });
  // }

  opendialogCustomizeMySession(offer: FullOffer): void {
    const quantity = this.quantitySelectedByUser || offer.traineeQuantity;
    const dialogRef = this.dialog.open(OpendialogCustomizeMySessionComponent, {
      data: {
        offer,
        quantity,
        showError: false,
        userKey: this.userKey,
        sessionKey: offer.sessionKey
      },
      minWidth: '50%',
      width: '100%',
      height: '80%',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe({
      next: res => {
        this.getPricingBasket();
        this.getBasketListUserConnectedFetch();
        this.dataService.paramsOfferIsComplete$.next(false);
      }
    });
  }

  getOffertoPersoNoComplete(): FullOffer[] {
    const offertoPerso = this.offerAddToPayment.filter(o => !o?.isComplete && o?.isSelected);
    return offertoPerso;
  }

  allMyOffersIsComplete(): boolean {
    const isAllComplete = this.offerAddToPayment.filter(o => o.isComplete && o.isSelected);
    const isSelected = this.offerAddToPayment.filter(o => o.isSelected);
    const offersToNull = [...this.offerAddToPayment.filter(o => o.fixedPrice <= 0 && o.isSelected)];

    return (isAllComplete.length === isSelected.length) && isSelected.length && this.cgvAccepted && offersToNull.length === 0 ? true : false;
  }

  allMyOffersIsCompleteForQuote(): boolean {
    const isAllComplete = this.offerAddToPayment.filter(o => o.isComplete && o.isSelected);
    const isSelected = this.offerAddToPayment.filter(o => o.isSelected);
    return (isAllComplete.length === isSelected.length) && isSelected.length ? true : false;
  }

  applyPromoCode(): void {
    this.sessionBasketService.applyPromoCodeToSessionBasket(this.userKey, this.f.promoCodeName.value).subscribe({
      next: res => {
        this.licences = [];
        this.basketWithPrice = res;
        this.totalPrice = res.grandTotal;
        this.licences = [...res.fullOfferList.filter(o => o.isLicence)];
        this.uiService.showSnackbar('Code Promo appliqué avec succès sur votre panier', false);
      },
      error: error => {
        console.error("error", error);
      }
    })
  }

  bookOffer(): void {
    this.authoToClick = false;
    const offerAddToPaymentFiltered = [...this.offerAddToPayment.filter(o => o.isComplete && o.isSelected), ...this.licences];
    const basketOffer: string[] = offerAddToPaymentFiltered.map((o, i) => o.offerKey.toString());
    const uniqueBasketOffer = [...new Set(basketOffer)];

    const sessionsList: SessionList[] = offerAddToPaymentFiltered.map((el) => {
      return {
        sessionBasketKey: el.sessionBasketKey,
        sessionTotalPrice: el.sessionTotalPrice
      };
    });


    const total = this.basketWithPrice.grandDiscount > 0 ? this.basketWithPrice.discountedGrandTotal : this.basketWithPrice.grandTotal;
    const myOrder = new BookBasketOffer(+this.userConnected.sub, uniqueBasketOffer, total, sessionsList);

    if (this.basketWithPrice.promoCodeDiscount && this.basketWithPrice.promoCodeName) {
      myOrder.promoCodeDiscount = this.basketWithPrice.promoCodeDiscount;
      myOrder.promoCodeName = this.basketWithPrice.promoCodeName;
    }

    if (this.basketWithPrice.fullOfferList.every((offer) => offer.isPayableAtClub === true && offer.isPayableOnline === false)) {
      // si au total il n'y a que des offres de paiement au club
      // this.openDialogConfirmPayemntToClub(myOrder);
      this.openDialogCommentAndPaymentToClub(myOrder);
    } else {
      this.openDialogConfirmBooked(myOrder, offerAddToPaymentFiltered);
    }

  }

  openDialogConfirmBooked(myOrder: BookBasketOffer, offers: FullOffer[]): void {
    const dialogRef = this.dialog.open(OpenDialogConfirmBookedComponent, {
      data: { myOrder, offers, licences: this.licences },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe({
      next: res => {
        this.authoToClick = true;
        this.cgvAccepted = false;
        if (res) {
          this.cancelBookedSession(res);
        } else {
          this.getBasketListUserConnected();
        }
      }
    });
  }

  openDialogCommentAndPaymentToClub(myOrder: BookBasketOffer) {
    const dialogRef = this.dialog.open(OpenDialogCommentBasketComponent, {
      data: { order: myOrder },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe({
      next: res => {
        if (res) {
          this.sessionBasketService.checkSessionBasketBookable(this.userKey).subscribe({
            next: res => {
              res.every((el: SessionBasketBookable) => el.isBookable) ?
                this.bookMyOrder(myOrder) :
                this.oneSessionNotAvailable();
            }
          });
        } else {
          this.authoToClick = true;
        }
      }
    });
  }

  oneSessionNotAvailable() {
    this.uiService.showSnackbar('Une de vos sessions n\'est plus disponible');
    this.getBasketListUserConnected();
  }

  openDialogConfirmPayemntToClub(myOrder: BookBasketOffer) {
    const dialogRef = this.dialog.open(OpenDialogConfirmComponent, {
      data: { text: 'Êtes-vous certain de réserver ce panier ? Le paiement se fera au club.' },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe({
      next: res => {
        if (res) {
          this.sessionBasketService.checkSessionBasketBookable(this.userKey).subscribe({
            next: res => {
              res.every((el: SessionBasketBookable) => el.isBookable) ?
                this.bookMyOrder(myOrder) :
                this.oneSessionNotAvailable();
            }
          });
        } else {
          this.authoToClick = true;
        }
      }
    });
  }

  bookMyOrder(myOrder): void {
    this.sessionBasketService.bookOffer(myOrder).subscribe({
      next: res => {
        this.cgvAccepted = false;
        // this.cancelBookedSession(res);
        this.authoToClick = true;
        this.uiService.showSnackbar('Réservation réussie');

        this.getBasketListUserConnected();
      }
    });
  }

  duplicateOffer({ sessionBasketKey }): void {
    const offerDuplicate = new SessionBasketOfferDuplicate(sessionBasketKey, this.userKey);

    this.sessionBasketService.duplicateSessionBasketOffer(offerDuplicate).subscribe({
      next: () => {
        this.getBasketListUserConnected();
      }
    });
  }

  deleteInMyShoppingBag(offer: FullOffer): void {
    this.sessionBasketService.deleteSessionBasketInMyBasket(this.userKey, +offer.sessionBasketKey).subscribe({
      next: () => { this.getBasketListUserConnected(); }
    });

    const index = this.wishes.findIndex(w => w.offerKey === offer.offerKey);

    if (index === -1) {
      const { sub: userKey } = this.authService.getDecodedToken();
      const wishlistUpdate = new WishList(+userKey, []);

      wishlistUpdate.offerKey = this.wishes.map(w => w.offerKey);

      const indexOfferInMyWishesUpdate = wishlistUpdate.offerKey.findIndex(o => o === offer.offerKey);

      indexOfferInMyWishesUpdate === -1 ?
        (wishlistUpdate.offerKey.push(offer.offerKey)) :
        (wishlistUpdate.offerKey.splice(indexOfferInMyWishesUpdate, 1));

      this.wishListService.updateWishList(wishlistUpdate).subscribe({
        next: myWhishes => { this.dataService.myWishes.next(myWhishes); }
      });
    }

  }

  getNewValueOfQuantity(event): void {
    this.quantitySelectedByUser = event.traineeQuantity;
    this.sessionBasketService.UpdateQuantityBasketOffer(event).subscribe({
      next: () => {
        const checkSession = new SelectBasketOffer(this.userKey, event.sessionBasketKey);
        this.sessionBasketService.checkSessionBasketComplete(checkSession).subscribe({
          next: (res) => {
            this.getBasketListUserConnectedFetch();
          }
        });
      }
    });
  }

  getOfferAddToPayment(offerAddToPayment: FullOffer[]): FullOffer[] {
    const basketOfferKeysMyShoppingBag = this.myShoppingBag.map(o => o.sessionBasketKey);
    const result = this.myShoppingBag.filter(o1 => !offerAddToPayment.some(o2 => o1.sessionBasketKey === o2.sessionBasketKey));
    const newOfferAddToPayment = [...offerAddToPayment, ...result];

    return newOfferAddToPayment.sort((a, b) => {
      const aValue = basketOfferKeysMyShoppingBag.indexOf(Object.values(a)[0]);
      const bValue = basketOfferKeysMyShoppingBag.indexOf(Object.values(b)[0]);
      return aValue - bValue;
    });
  }

  noOfferInBasket(): FullOffer[] {
    return this.offerAddToPayment.filter(el => el.isSelected);
  }

  getStatuPriceOfOffer(offer: FullOffer, i: number): string {
    let status = 'Non personnalisée';
    if (offer.isComplete && offer.isSelected) {
      status = `${this.offerAddToPayment[i]?.sessionTotalPrice}€`;
    } else {
      status = '';
    }
    // else if (offer.isComplete && !offer.isSelected) {
    //   status = 'Non selectionnée';
    // } else if (!offer.isComplete && offer.isSelected) {
    //   status = 'Non personnalisée';
    // }
    return status;
  }

  getTooltip(value: string): string {
    return this.tooltip.getTooltip(value);
  }

  updateSessionsBasket(event: boolean): void {
    if (event) {
      this.getPricingBasket();
      this.getBasketListUserConnected();
      this.dataService.paramsOfferIsComplete$.next(false);

    }
  }

  getSessionOfferBasket(offerBasket: FullOffer): OfferSession {
    return offerBasket.sessions?.find(o => o.sessionKey === offerBasket.sessionKey);
  }

  getMessageAddOfferToPaiment(): void {
    this.uiService.showSnackbar('Vous devez selectionner l\'offre pour réaliser cette action');
  }

  acceptCGV(event): void {
    this.cgvAccepted = event.checked;
  }

  isInBasket({ offerKey }): boolean {
    const indexOffer = this.myShoppingBag.findIndex(offer => offer.offerKey === offerKey);
    return indexOffer === -1 ? false : true;
  }

  addToMyShoppingBag(offer: FullOffer): void {
    const { sub: userKey } = this.authService.getDecodedToken();

    const listClubCode = this.offerAddToPayment.filter(o => o.isSelected && o.clubCode).map(o => o.clubCode);
    const check = offer.clubCode === listClubCode[0] || !listClubCode.length ? true : false;
    if (!check) {
      this.uiService.showSnackbar('Vous ne pouvez pas ajouter une offre d\'un club différent dans votre panier');
    } else {
      this.sessionBasketService.addInMyBasket(+userKey, offer.offerKey).subscribe({
        next: myShoppingBag => {
          this.dataService.myShoppingBag.next(myShoppingBag as FullOffer[]);
          this.router.navigate(['/home/my-shopping-bag']);
        }
      });
    }

  }

  isInMyWishes(offerId: string): object {
    const indexOfferInMyWhishes = this.wishes?.findIndex(o => o.offerKey === +offerId);
    return indexOfferInMyWhishes === -1 ? this.faHeartEmpty : this.faHeartFull;
  }

  getColorOfHeart(offerId: string): string {
    const indexOfferInMyWhishes = this.wishes?.findIndex(o => o.offerKey === +offerId);
    return indexOfferInMyWhishes === -1 ? '#2c296d !important' : '#ff0000';
  }

  addOrDeleteToMyWish(offer: FullOffer, event): void {
    this.authService.refreshToken();

    if (this.authService.isAuth()) {

      const { sub: userKey } = this.authService.getDecodedToken();
      const wishlistUpdate = new WishList(+userKey, []);

      wishlistUpdate.offerKey = this.wishes.map(w => w.offerKey);

      const indexOfferInMyWishesUpdate = wishlistUpdate.offerKey.findIndex(o => o === offer.offerKey);

      indexOfferInMyWishesUpdate === -1 ?
        (wishlistUpdate.offerKey.push(offer.offerKey)) :
        (wishlistUpdate.offerKey.splice(indexOfferInMyWishesUpdate, 1));

      this.wishListService.updateWishList(wishlistUpdate).subscribe({
        next: myWhishes => { this.dataService.myWishes.next(myWhishes); }
      });
    } else {
      const dialogRef = this.dialog.open(OpendialogLoginComponent);

      dialogRef.afterClosed().subscribe({
        next: () => {
          const { sub: userKey } = this.authService.getDecodedToken();
          const wishlistUpdate = new WishList(+userKey, []);

          this.wishes.forEach(wish => {
            wishlistUpdate.offerKey.push(wish.offerKey);
          });

          const indexOfferInMyWishesUpdate = wishlistUpdate.offerKey.findIndex(o => o === offer.offerKey);

          indexOfferInMyWishesUpdate === -1 ?
            (wishlistUpdate.offerKey.push(offer.offerKey)) :
            (wishlistUpdate.offerKey.splice(indexOfferInMyWishesUpdate, 1));

          this.wishListService.updateWishList(wishlistUpdate).subscribe({
            next: myWhishes => { this.dataService.myWishes.next(myWhishes); }
          });
        }
      });
    }
  }

  getPdfBasket(): void {
    const { sub: userKey } = this.authService.getDecodedToken();

    if (this.totalPrice > 0 && this.allMyOffersIsCompleteForQuote()) {
      this.pdfService.getPdfBasket(+userKey).subscribe({
        next: blob => {
          const data = window.URL.createObjectURL(<any>blob.body);
          const anchor = document.createElement('a');
          const date = new Date();
          const time = date.getFullYear() + ('0' + (date.getMonth() + 1)).slice(-2) + ('0' + date.getDate()).slice(-2) + ('0' + date.getHours()).slice(-2) + ('0' + date.getMinutes()).slice(-2) + ('0' + date.getSeconds()).slice(-2);
          anchor.href = data;
          anchor.download = `NPHDF-${date.getFullYear()}-${this.myShoppingBag[0].sessionBasketKey}-${time}`;
          anchor.click();

          setTimeout(() => {
            window.URL.revokeObjectURL(data);
          }, 100);
        }
      });

    } else {
      this.uiService.showSnackbar('Vous devez configurer toutes vos offres pour télécharger votre devis.');
    }
  }

  downloadCGV(): void {
    const clubCode = [...this.offerAddToPayment.filter(o => !o.isLicence)][0].clubCode;
    this.getCGV(clubCode);
  }


  private getPricingBasket(): void {
    this.sessionBasketService.getPriceSession(this.userKey).subscribe({
      next: basketWithPrice => {

        this.basketWithPrice = basketWithPrice;
        const offer = this.getOfferAddToPayment([...basketWithPrice?.fullOfferList]);
        this.offerAddToPayment = offer.filter(o => !o.isLicence);

        this.licences = offer.filter(o => o.isLicence);
        this.activePromoCode = this.checkCodePromo(this.offerAddToPayment);
        this.totalPrice = basketWithPrice.grandTotal;
        if (this.innerWidth <= 768) {
          this.dataService.updateBasketInMobile$.next(false);
        }

        // const clubCode = [... new Set(basketWithPrice.fullOfferList.map(o => o.clubCode))][0];
        // this.getCGV(clubCode);
      }
    });
  }

  private getBasketListUserConnected(type?: string): void {
    if (type !== 'selection') { this.loading = true; }
    this.sessionBasketService.getBasketList(this.userKey).subscribe({
      next: basket => {
        this.myShoppingBag = basket.sort((a, b) => {
          return (b.isSelected as any) - (a.isSelected as any);
        });

        this.dataService.myShoppingBag.next(basket);
        if (type !== 'selection') { this.loading = false; }

        this.activePromoCode = this.checkCodePromo(basket);
        if (this.activePromoCode) { this.initForm(); }
      }
    });
  }

  private getBasketListUserConnectedFetch(): void {
    fetch(`${environment.apiUrl}/SessionBasket/${this.userKey}`, {
      method: 'get',
      headers: { authorization: `Bearer ${localStorage.getItem(`${environment.tokenKey}`)} ` }
    })
      .then(response => response.json())
      .then((response) => {
        this.myShoppingBag = response.sort((a, b) => {
          return (b.isSelected as any) - (a.isSelected as any);
        });

        this.dataService.myShoppingBag.next(this.myShoppingBag);
        this.activePromoCode = this.checkCodePromo(response);
        this.getPricingBasket();

      })
      .catch((error) => {
        console.error('error', error);
      });
  }

  private checkCodePromo(basket: FullOffer[]): boolean {
    const basketFilter = basket.filter(o => o.isSelected);
    const offerKeys = basketFilter.map(o => o.offerKey);
    const offerKeyBase = offerKeys[0];
    return offerKeys.every(o => o === offerKeyBase) && basketFilter.every(o => o.isComplete);
  }

  private getCGV(clubCode: string): void {
    this.clubService.getCGV(clubCode).subscribe({
      next: async cgv => {
        if (cgv) {
          const pdf = await `data:application/pdf;base64,${cgv}`;
          const anchor = document.createElement('a');
          anchor.href = pdf;
          anchor.download = `Conditions_générales_de_vente`;
          anchor.click();
        } else {
          this.uiService.showSnackbar('Ce club n\'a pas de conditions générales de vente');
        }
      }
    });
  }

  private cancelBookedSession(bookingKey: number) {
    this.bookingService.cancelBookedSession(bookingKey).subscribe({
      next: res => {
        this.getBasketListUserConnected();
      }
    });
  }

  private getWishList(): void {
    const { sub: userKey } = this.authService.getDecodedToken();
    this.wishListService.getWishList(+userKey).subscribe({
      next: wishes => {
        this.wishesBase = wishes;
        this.wishes = wishes.filter(w => this.myShoppingBag.findIndex(o => o.offerKey === w.offerKey) === -1);
        this.dataService.myWishes.next(wishes);
      }
    });
  }

  private initComponent(): void {
    this.innerWidth = window.innerWidth;
    this.dataService.bookedOpen$.next(false);
    this.dataService.tabHome$.next('basket');
    this.dataService.resetPopUp();
    this.dataService.titleHomePage.next('Mon panier');

    this.userKey = +this.authService.getDecodedToken().sub;
  }

  get f() {
    return this.discountForm.controls;
  }

  private initForm(): void {
    this.discountForm = this.formBuilder.group({
      promoCodeName: ['']
    });
  }

  private initSub(): void {
    this.subscription
      .add(
        this.dataService.myShoppingBag.subscribe({
          next: myShoppingBag => {
            this.myShoppingBag = myShoppingBag.sort((a, b) => {
              return (b.isSelected as any) - (a.isSelected as any);
            });

            // this.myShoppingBag.forEach(o => {
            //   this.getNewValueOfQuantity(o);
            // });
            this.offerIsCompleted = myShoppingBag.filter(o => (!o.isComplete && !o?.parameters) || o.isComplete);
            this.getPricingBasket();
            this.cdr.detectChanges();

            this.getWishList();

            this.dataService.myWishes.subscribe({
              next: wishes => {
                this.wishesBase = wishes;
                this.wishes = wishes?.filter(w => this.myShoppingBag.findIndex(o => o.offerKey === w.offerKey) === -1);
              }
            });
          }
        })
      )
      .add(
        this.authService.currentUser.subscribe({
          next: user => this.userConnected = user
        })
      )
      .add(
        this.dataService.afterUpdateTraineesInBasket$.subscribe({
          next: update => {
            if (update) {
              // this.getBasketListUserConnected();
              this.getBasketListUserConnectedFetch();
              this.dataService.paramsOfferIsComplete$.next(false);
              this.dataService.afterUpdateTraineesInBasket$.next(false);
            }
          }
        })
      )
      .add(
        this.dataService.themeDemo$.subscribe({
          next: isDemo => {
            this.isDemo = isDemo;
          }
        }));
  }

  openDialogHelp() {
    this.dialog.open(OpenDialogHelpComponent, {
      data: { helpVideoKey: 3 },
      width: '60%',
      maxHeight: '90%'
    });
  }

  goHome(): void {
    let clubCode = [...this.offerAddToPayment.filter(o => !o.isLicence)][0].clubCode;
    sessionStorage.setItem('clubCodeForHomeOffers', clubCode);
    const urlInSessionStorage = sessionStorage.getItem('route');
    sessionStorage.getItem('route') ?
      this.router.navigateByUrl(urlInSessionStorage) :
      this.router.navigate(['/home']);
  }

  removePromoCode() {
    this.discountForm.reset();
    this.getPricingBasket();
  }
}
